// Tablas acumuladas. Equivalente a stats() del original
// (public/cabrillo/src/plantilla.html:107-113), construyendo el HTML de
// las tablas a partir de los datos ya calculados por
// motor.estadisticas() — render ≠ motor, sin recalcular nada.

import { CONT, CNAME, CL } from '../constantes.js';
import { bl } from '../geo.js';

/**
 * @param {{mx: HTMLElement, tc: HTMLElement, tz: HTMLElement}} els
 * @param {ReturnType<import('../motor.js').crearAnalizador>} motor
 */
export function montar(els, motor) {
    function actualizar() {
        const { bands } = motor.modelo;
        const { bf } = motor.obtenerEstado();
        const { matrizContinenteBanda: m, porPais: pc, porZona: pz, nombresPais: CN } = motor.estadisticas();

        let mm = 1;
        m.forEach((fila) => fila.forEach((v) => (mm = Math.max(mm, v))));

        const bs = bf < 0 ? bands.map((b, i) => i) : [bf];
        const filas = CONT.map((c, i) => i).filter((i) => motor.modelo.D.some((r) => r[2] == i && (bf < 0 || r[1] == bf)));

        els.mx.innerHTML =
            '<table><tr><th></th>' +
            bs.map((j) => `<th>${bl(bands[j])}</th>`).join('') +
            '<th>Total</th></tr>' +
            filas
                .map(
                    (i) =>
                        `<tr><td><i style="display:inline-block;width:9px;height:9px;border-radius:2px;background:${CL[CONT[i]]};margin-right:6px"></i>${CNAME[CONT[i]]}</td>` +
                        bs
                            .map((j) => m[i][j])
                            .map((v) => `<td style="background:${CL[CONT[i]]}${Math.round(20 + (v / mm) * 70).toString(16).padStart(2, '0')}">${v || '·'}</td>`)
                            .join('') +
                        `<td><b>${m[i].reduce((a, c) => a + c, 0)}</b></td></tr>`
                )
                .join('') +
            '</table>';

        const list = (o, f) => {
            const t = Object.entries(o).sort((a, b) => b[1] - a[1]).slice(0, 10);
            const mx = t[0] ? t[0][1] : 1;
            return t.map(([k, v]) => `<div class="cab-row"><b>${f(k)}</b><s><u style="width:${(v / mx) * 100}%"></u></s><span>${v}</span></div>`).join('');
        };

        els.tc.innerHTML = list(pc, (k) => CN[k]);
        els.tz.innerHTML = list(pz, (k) => 'Zona CQ ' + k);
    }

    actualizar();
    const desuscribir = motor.subscribe(actualizar);
    return { actualizar, destruir: desuscribir };
}
